<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>Plan de Sucesión</h6>
                </v-card-title>
            </v-card>

            <v-data-table dense :headers="headers" :items="listado" locale="es-ar" style="font-size: 12px;"
                class="elevation-1, tabla-pequena" :items-per-page="500" hide-default-footer>
                <template v-slot:item.legajo="{ item }">
                    <font class="tabla-pequena"> {{ item.legajo }} </font>
                </template>
                <template v-slot:item.nombre="{ item }">
                    <font class="tabla-pequena"> {{ item.nombre }} </font>
                </template>
                <template v-slot:item.fechanacimiento="{ item }">
                    <font class="tabla-pequena"> {{ item.fechanacimiento }} </font>
                </template>
                <template v-slot:item.edad="{ item }">
                    <v-chip :color="getColor(item)" class="font-class-name">
                        {{ item.edad }}
                    </v-chip>
                </template>
                <template v-slot:item.mantienepuesto="{ item }">
                    <v-select dense class="font-class-name" v-model="item.mantienepuesto" :items="mantiene"
                        item-text="valor" item-value="valor"></v-select>
                </template>
                <template v-slot:item.reemplazo="{ item }">
                    <v-text-field class="font-class-name" dense v-model="item.reemplazo"></v-text-field>
                </template>
                <template v-slot:item.accion="{ item }">
                    <v-text-field class="font-class-name" dense v-model="item.accion"></v-text-field>
                </template>
                <template v-slot:item.accionrealizada="{ item }">
                    <v-text-field class="font-class-name" dense v-model="item.accionrealizada"></v-text-field>
                </template>
            </v-data-table>
            <v-card>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text :disabled="deshabilitar" @click="guardar()">
                        Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-app>
    </div>
</template>
<style scoped>
.tabla-pequena {
    font-size: 10px !important;
}

.font-class-name {
    font-size: 12px;
}
</style>
<script>

import axios from "../../axios-auth";

export default {

    data: (vm) => ({
        deshabilitar: false,
        listado: [],
        mantiene: [{ valor: "SI" },
        { valor: "NO" }
        ],
        headers: [
            {
                text: "Legajo",
                align: "center",
                sortable: false,
                value: "legajo",
            },
            { text: "Nombre", value: "nombre", sortable: false },
            { text: "Fecha de Nacimiento", value: "fechanacimiento", align: "center", sortable: false },
            { text: "Edad", value: "edad", sortable: false, align: "center" },
            { text: "Mantener puesto", value: "mantienepuesto", sortable: false, align: "center" },
            { text: "Posible Reemplazo", value: "reemplazo", sortable: false },
            { text: "Acciones propuestas", value: "accion", sortable: false },
            { text: "Acciones realizadas", value: "accionrealizada", sortable: false },
        ],
    }),

    computed: {
        show: {
            get() {
                this.cargarListados();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {

        getColor(item) {
            if ((item.sexo == "F" && item.edad >= "60") || (item.sexo != "F" && item.edad >= "65")) { return "red"; }
            else if ((item.sexo == "F" && item.edad < "60" && item.edad >= "55") || (item.sexo != "F" && item.edad < "65" && item.edad >= "60")) {
                return "orange";
            }
            else if ((item.sexo == "F" && item.edad < "55" && item.edad >= "50") || (item.sexo != "F" && item.edad < "60" && item.edad >= "55")) {
                return "yellow"
            }
            else {
                return "green";
            }

        },

        cargarListados() {
            this.vaciarModels();
            let self = this;

            axios
                .get("/RRHH/ListadoSucesion?", {
                })
                .then((response) => {
                    self.listado = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        guardar() {
            this.deshabilitar = true;
            this.$swal({
                title: "Guardar Plan de Sucesión",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    // var datos = {
                    //     listado: this.listado

                    // };

                    let self = this;
                    axios
                        .post("/RRHH/GuardarPlanSucesion", this.listado)
                        .then((response) => {
                            self.showAlert({
                                icon: "success",
                                title: "Plan de Sucesión guardado con éxito",
                                vm: self,
                            });
                            self.vaciarListado();
                            setTimeout(() => {
                                self.$router.push({ name: "MainRRHH" });
                            }, 2000);
                            self.$emit("close");
                        })
                        .catch({});
                }
            });
        },

        vaciarModels() {
            this.listado = [];
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 1500,
            });
        },
    },
};
</script>